/**
 * Utility to extract operationName from a GraphQL request body
 * @param requestInit - The RequestInit object containing the request body
 * @returns The operationName if present, otherwise undefined
 */
export function getViewerOperationName(requestInit?: RequestInit) {
  if (typeof requestInit?.body !== 'string') return;

  try {
    const parsedBody = JSON.parse(requestInit.body);
    return typeof parsedBody?.operationName === 'string' ? parsedBody.operationName : undefined;
  } catch {
    console.error('Failed to parse operationName');
    return;
  }
}
